import React, { useState, useEffect } from 'react';
import { marked } from 'marked';
import Header from '../common/Header';

const CHANGELOG_MD = require('./CHANGELOG.md');

function Changelog() {
  const [markdown, setMarkDown] = useState('');

  useEffect(() => {
    fetch(CHANGELOG_MD)
      .then(response => response.text())
      .then((text) => {
        return setMarkDown(marked(text));
      });
  });

  return (
    <>
      <Header />
      <div className="changelog-container" dangerouslySetInnerHTML={{ __html: markdown }} dir="ltr" />
    </>
  );
}

export default Changelog;
